module.exports = __webpack_public_path__ + "img/wc.91225dea.png";